import http from "../http-common";

class UserDataService {

    async checkAuth(user: { userName: string, token: string}) {
      const json = JSON.stringify(user);
      return await http.post("/users/auth", json);
    }
  }

  export default new UserDataService();